import { IPagination } from 'app/types/common';

export interface IGroupImportsState {
  readonly groupImportsById?: any;
  readonly groupImportIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectGroupImportLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddGroupImport?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationGroupImportIds?: string[];
  readonly currentGroupImportId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IGroupImportsSelector extends IGroupImportsState {
  readonly currentGroupImport?: any;
  readonly currentFormGroupImport?: any;
  readonly groupImportsFilteredByTagInSelectFormat?: any;
  readonly groupImportsByIdInSelectFormat?: any;
  readonly groupImportsFilteredByOrganisationInSelectFormat?: any;
}

export enum GroupImportsActionTypes {
  GET_ALL_GROUP_IMPORTS_REQUESTED = 'redux-app/group-imports/GET_ALL_GROUP_IMPORTS_REQUESTED',
  GET_ALL_GROUP_IMPORTS_PENDING = 'redux-app/group-imports/GET_ALL_GROUP_IMPORTS_PENDING',
  GET_ALL_GROUP_IMPORTS_SUCCESS = 'redux-app/group-imports/GET_ALL_GROUP_IMPORTS_SUCCESS',
  GET_ALL_GROUP_IMPORTS_FAIL = 'redux-app/group-imports/GET_ALL_GROUP_IMPORTS_FAIL',
  GET_GROUP_IMPORT_REQUESTED = 'redux-app/group-imports/GET_GROUP_IMPORT_REQUESTED',
  GET_GROUP_IMPORT_PENDING = 'redux-app/group-imports/GET_GROUP_IMPORT_PENDING',
  GET_GROUP_IMPORT_SUCCESS = 'redux-app/group-imports/GET_GROUP_IMPORT_SUCCESS',
  GET_GROUP_IMPORT_FAIL = 'redux-app/group-imports/GET_GROUP_IMPORT_FAIL',
  UPDATE_GROUP_IMPORT_REQUESTED = 'redux-app/group-imports/UPDATE_GROUP_IMPORT_REQUESTED',
  UPDATE_GROUP_IMPORT_PENDING = 'redux-app/group-imports/UPDATE_GROUP_IMPORT_PENDING',
  UPDATE_GROUP_IMPORT_SUCCESS = 'redux-app/group-imports/UPDATE_GROUP_IMPORT_SUCCESS',
  UPDATE_GROUP_IMPORT_FAIL = 'redux-app/group-imports/UPDATE_GROUP_IMPORT_FAIL',
  CREATE_GROUP_IMPORT_REQUESTED = 'redux-app/group-imports/CREATE_GROUP_IMPORT_REQUESTED',
  CREATE_GROUP_IMPORT_PENDING = 'redux-app/group-imports/CREATE_GROUP_IMPORT_PENDING',
  CREATE_GROUP_IMPORT_SUCCESS = 'redux-app/group-imports/CREATE_GROUP_IMPORT_SUCCESS',
  CREATE_GROUP_IMPORT_FAIL = 'redux-app/group-imports/CREATE_GROUP_IMPORT_FAIL',
  DELETE_GROUP_IMPORT_REQUESTED = 'redux-app/group-imports/DELETE_GROUP_IMPORT_REQUESTED',
  DELETE_GROUP_IMPORT_PENDING = 'redux-app/group-imports/DELETE_GROUP_IMPORT_PENDING',
  DELETE_GROUP_IMPORT_SUCCESS = 'redux-app/group-imports/DELETE_GROUP_IMPORT_SUCCESS',
  DELETE_GROUP_IMPORT_FAIL = 'redux-app/group-imports/DELETE_GROUP_IMPORT_FAIL',
  SELECT_GROUP_IMPORT_REQUESTED = 'redux-app/group-imports/SELECT_GROUP_IMPORT_REQUESTED',
}

export default null;
